<template>
    <div class="exam_page">
        <div class="exam_page_header">
            <div class="exam_page_header_title">
                Estás por comenzar tu examen
            </div>
        </div>
        <div class="exam_page_disclamer_top">
            Todo el proceso te tomará máximo una hora y <span>podrás decidir el mejor momento</span> para realizar cada paso.
        </div>
        <div class="exam_page_instructions">
            El examen está dividido en cinco niveles, desde Elemental hasta Avanzado. Si respondes correctamente más del 50% de las preguntas en cada nivel, pasarás al siguiente. En caso contrario, el examen finalizará y pasarás a programar la fecha y hora en la que desees rendir la asesoría.
        </div>
        <div class="exam_page_steps">
            <div class="step">
                <div class="step_image">
                    <img src="@/assets/images/exam/step1.svg" alt="">
                </div>
                <div class="step_name">
                    1. Examen
                </div>
                <div class="step_description">
                    <span>Prueba de diagnóstico en línea</span> para determinar tu nivel de conocimiento del idioma.
                </div>
                <div class="step_time">
                    30 minutos
                </div>
            </div>

            <div class="step">
                <div class="step_image">
                    <img src="@/assets/images/exam/step2.svg" alt="">
                </div>
                <div class="step_name">
                    2. Asesoría
                </div>
                <div class="step_description">
                    <span>Llamada telefónica con un asesor</span> para conocer tu capacidad oral, quien te ayudará a elegir el curso ideal.
                </div>
                <div class="step_time">
                    20 minutos
                </div>
            </div>

            <div class="step">
                <div class="step_image">
                    <img src="@/assets/images/exam/step3.svg" alt="">
                </div>
                <div class="step_name">
                    3. Matrícula
                </div>
                <div class="step_description">
                    Con el nivel asignado procederás a realizar tu <span>matrícula en línea</span>.
                </div>
                <div class="step_time">
                    10 minutos
                </div>
            </div>
        </div>
        <div class="exam_page_disclamer">
            Puedes realizar <span>todo el proceso en línea en aproximadamente una hora</span>, si <br>así lo deseas. En caso contrario, puedes programar tu asesoría en el horario <br>más conveniente para ti.
        </div>
        <div class="exam_page_footer">

            <v-btn
                color="primary"
                class="btn-basic uppercase"
                @click="registerExam"
                >
                Iniciar examen
            </v-btn>

            <router-link to="/poll" class="go_previous">
                 <v-icon style="font-size: 20px">navigate_before</v-icon> Anterior
            </router-link>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    computed: {
        ...mapGetters({
            language: "language",
            program: "program",
            postulation: "postulation",
            postulationIsNull: "postulationIsNull"
        })
    },
    methods: {
        ...mapActions(['verifyPostulation']),
        registerExam() {
            this.$router.push({ path: `/evaluation` });
        }
    },
    mounted() {
        this.verifyPostulation();

        if(this.postulationIsNull){
            this.$router.push({ path: `/principal` });
        }
        this.user = this.$store.state.usuario;
        // console.log(this.user);
        //
        // console.log(this.program);
        // console.log(this.language);
        // console.log(this.postulation);
    },
}
</script>
